// Overview (the store's home page).
const overviewEn = {
  "ov.greeting_morning": "Good morning, {name}",
  "ov.greeting_afternoon": "Good afternoon, {name}",
  "ov.greeting_evening": "Good evening, {name}",
  "ov.welcome": "Welcome back",
  "ov.live": "Your store is open to customers",
  "ov.locked": "Your store is password protected",
  "ov.locked_hint": "Only you and your team can see it until you launch.",
  "ov.launch": "Launch store",
  "ov.trial_left": "{days, plural, one {# day left in your trial} other {# days left in your trial}}",
  "ov.today": "Today",
  "ov.today_sales": "Sales today",
  "ov.today_orders": "Orders today",
  "ov.pulse": "How your store is doing",
  "ov.period": "Period",
  "ov.period.last_7_days": "7 days",
  "ov.period.last_30_days": "30 days",
  "ov.period.last_90_days": "90 days",
  "ov.vs_previous": "vs previous period",
  "ov.no_change": "No earlier data",
  "ov.visitors": "Visitors",
  "ov.sales_over_time": "Sales over time",
  "ov.full_report": "Open analytics",
  "ov.attention": "Needs your attention",
  "ov.attention.unfulfilled": "Orders to fulfill",
  "ov.attention.unpaid": "Orders awaiting payment",
  "ov.attention.cod": "Cash on delivery orders",
  "ov.attention.low_stock": "Items running low",
  "ov.caught_up": "You're all caught up",
  "ov.caught_up_hint": "New orders and low stock will show up here.",
  "ov.top_products": "Best sellers",
  "ov.top_products_empty": "Your best-selling products will show up here after your first sales.",
  "ov.units": "{count, plural, one {# sold} other {# sold}}",
  "ov.storefront": "Your storefront",
  "ov.customize": "Customize theme",
  "ov.domains": "Domains",
  "ov.copy_link": "Copy link",
  "ov.copied": "Link copied",
  "ov.quick": "Quick actions",
  "ov.guide_title": "Get your store ready",
  "ov.guide_all": "Show all {count} steps",
  "ov.guide_fewer": "Show fewer steps",
  "ov.guide_left": "{count, plural, one {# step left} other {# steps left}}",
  "ov.no_sales_yet": "No sales yet in this period. They'll show up here as orders come in.",
} as const;

export default overviewEn;
